/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Intent, Size, Tab, TabId, Tabs, Tag } from "@blueprintjs/core"
import IScalarForm from "../interface/IScalarForm"
import Scalar from "./Scalar"
import { __ } from "@libs/utilities"
import { MediaChooser } from "@libs/useful"
import { useEffect, useState } from "react"
import FontAwesome from "../utils/FontAwesome"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"

enum ICON_SIZE {
    "fa-1x" = "fa-1x",
    "fa-2x" = "fa-2x",
    "fa-3x" = "fa-3x"
}


/* Protopia Ecosystem component */
export interface IIconProps {
   
}
const Icon = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<IconEnabled {...props} />}
        desabledForm={<IconDisabled {...props} />}
    />
}
export default Icon

const IconEnabled = ( props: IScalarForm ): JSX.Element => {
    const value = useSyncState<string>(props.value) 
    const [size, setSize] = useState<ICON_SIZE>(ICON_SIZE["fa-1x"])
    const [navBarID, setNavBarID ] = useState<TabId>("icon")
    useEffect(() => {
      value.set(props.value)
    }, [props.value] )

    const onValue = ( _value: string ) => {
      value.set( _value )
      onChangeIcon()
    }
    const onSize = (size: string | number) => {
        const sz = "fa-" + size +"x" as ICON_SIZE
        setSize( ICON_SIZE[ sz ] )
        onChangeIcon()
      }
    const onChangeIcon = () => { 
        setTimeout(() => props.onChange ? props.onChange( value.get() + " " + size, props.field, "" ): null , 200)    
    }
    const  onImage= (src: string, file: any, name: string) => {
      if(props.onChange) {
        props.onChange( src, file, name )
      }
    }
    const getIcon = () => { 
        return (
          <div className={`d-flex flex-column w-100 ${ props.className}`} style={{height:199 }}> 
            <FontAwesome value={value.get()} onChange={ onValue } /> 
            <div className="px-3 d-flex">
              <Button 
                variant={ size === ICON_SIZE["fa-1x"] ? ButtonVariant.SOLID : ButtonVariant.MINIMAL } 
                intent={size === ICON_SIZE["fa-1x"] ? Intent.DANGER : Intent.NONE} 
                size={ Size.LARGE } 
                className=" " 
                onClick={() => onSize(1)}
              >
                1x
              </Button>
              <Button 
                variant={ size === ICON_SIZE["fa-2x"] ? ButtonVariant.SOLID : ButtonVariant.MINIMAL }  
                intent={size === ICON_SIZE["fa-2x"] ? Intent.DANGER : Intent.NONE} 
                size={ Size.LARGE } 
                className=" " 
                onClick={() => onSize(2)}
              >
                2x
              </Button>
              <Button 
                variant={ size === ICON_SIZE["fa-3x"] ? ButtonVariant.SOLID : ButtonVariant.MINIMAL }  
                intent={size === ICON_SIZE["fa-3x"] ? Intent.DANGER : Intent.NONE} 
                size={ Size.LARGE }
                className="  " 
                onClick={() => onSize(3)}
              >
                3x
              </Button>
            </div>             
          </div>
        )
    } 
    return <div style={{ width:"100%" }}>
      <Tabs
        animate={false}
        selectedTabId={ navBarID}
        onChange={ setNavBarID } 
        className="w-100 icon-scalar-container"
      >
        <Tab
          id="image"
          title={<div className="d-flex  align-items-center">
            <i className="ml-3 far fa-image mr-2"/>
            <div className="super-small">
              {__("image")}
            </div>
          </div>}
          className=" "
          panel={ 
            <MediaChooser
              url={value.get()}
              onChange={onImage}
              height={100}
              id=""
              isUploadHide={ props.isUploadHide }
              isURLHide={ props.isURLHide }
            />
          }
        />
        <Tab
          id="icon"
          title={<div className="d-flex  align-items-center">
            <i className="fas fa-asterisk mr-2"/>
            <div className="super-small">
              {__("icon")}
            </div>
          </div>}
          className=" "
          panel={ getIcon() }
        />
      </Tabs>      
    </div>
}


const IconDisabled = ( props: IScalarForm ): JSX.Element => {
    return (
        <div className={` ${props.className}`}>
          <i className="fas fa-at" />
          <div className="px-0 my-2">
            {
              props.value
                ? (
                  <Tag minimal>
                    {`${ props.value } `}
                  </Tag>
                )
                : null
            }
          </div>
        </div>
      )
}